import { fetchSinTokenExterno, fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { types } from "../../types/types";
import { prepareEmpresaDesdeAFIP } from "../../helpers/prepareEmpresa";
import { startAlerta } from "../ui/alertas";
import EmpresasService from '../../services/EmpresasServices'

// ABM EMPRESA - EMPIEZA
export const seleccionarEmpresaABM = (empresa) => {
  return (dispatch) => {
    dispatch({
      type: types.seleccionarEmpresaABM,
      payload: empresa,
    });
  };
};

export const desSeleccionarEmpresaABM = () => {
  return (dispatch) => {
    dispatch({
      type: types.desSeleccionarEmpresaABM
    });
  };
};

export const empresaStoreOrUpdate = (empresa, id=null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      let response=null;
      if(id){
        empresa.idEmpresa = id;
        response = await EmpresasService.actualizar(empresa, id);
      }else{
        response = await EmpresasService.guardar(empresa);
      }
      
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(
            startAlerta(
              `Almacenamiento de ${empresa.denominacion}`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch({
            type: types.updateStoreEmpresaABM,
            payload:empresa
          });
        } else {
          dispatch(startAlerta(response.errores, "error", "Error"));
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error.errores, "error", "Error"));
    }
  };
};

// ABM EMPRESA - TERMINA

export const empresaTraerAFIPStart = () => ({
  type: types.empresaTraerAFIPStart,
});
export const empresaLimpiar = () => ({
  type: types.empresaLimpiar,
});
export const empresaTraerAFIPError = (error) => ({
  type: types.empresaTraerAFIPError,
  payload: error,
});

export const afiliadoTraerAFIPStart = () => ({
  type: types.afiliadoTraerAFIPStart,
});
export const empresaTraerAFIPSuccess = (payload) => {
  return {
    type: types.empresaTraerAFIPSuccess,
    payload: payload,
  };
};
export const empresaTraerPorCUITStart = () => ({
  type: types.empresaTraerPorCUITStart,
});
export const empresaTraerPorCUITError = (error) => ({
  type: types.empresaTraerPorCUITError,
});
export const empresaInsertStart = () => ({
  type: types.empresaInsertStart,
});
export const empresaInserterror = (error) => ({
  type: types.empresaInsertError,
  payload: error,
});
export const empresaInsertSuccess = (payload) => {
  return {
    type: types.empresaInsertSuccess,
    payload: payload,
  };
};
export const empresaUpdateStart = () => ({
  type: types.empresaUpdateStart,
});
export const empresaUpdateerror = (error) => ({
  type: types.empresaUpdateError,
  payload: error,
});
export const empresaUpdateSuccess = (payload) => {
  return {
    type: types.empresaUpdated,
    payload: payload,
  };
};
export const empresaTraerPorCUITSuccess = (payload) => {
  return {
    type: types.empresaTraerPorCUITSuccess,
    payload: payload,
  };
};
export const empresaStartUpdate = (empresa) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(empresaStartUpdate())
      const response = await fetchConToken(`Empresas`, empresa, "PUT");
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          //const empresa = await response.json();
          console.log("empresaUpd", empresa);
          dispatch(
            startAlerta(
              `Modificacion de ${empresa.denominacion}`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(empresaUpdateSuccess(empresa));
        } else {
          dispatch(startAlerta(response, "error", "Error"));
          dispatch(empresaUpdateerror(response));
          console.log(response);
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, "error", "Error"));
      dispatch(empresaInserterror(error));
      console.log("error en update empresa afiliado", error);
    }
  };
};
export const empresaStartInsert = (empresa) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(empresaInsertStart())
      const response = await fetchConToken(`Empresas`, empresa, "POST");
      console.log("peticion", response);
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const empresaInsertada = await response.json();
          console.log("empresaInsertada", empresaInsertada);
          dispatch(
            startAlerta(
              `Alta de ${empresaInsertada.denominacion}`,
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(empresaInsertSuccess(empresaInsertada));
        } else {
          dispatch(startAlerta(response, "error", "Error"));
          dispatch(empresaInserterror(response));
          console.log(response);
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, "error", "Error"));
      dispatch(empresaInserterror(error));
      console.log("error en update empresa afiliado", error);
    }
  };
};
export const fetchAFIP = (CUIT) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      dispatch(empresaTraerAFIPStart());
      const response = await fetchSinTokenExterno(
        `https://www.utedyc.org.ar/webapiutedyc/api/`,
        `Empresas/TraerDeAFIP?CUIT=${CUIT}`
      );
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const r = await response.json();
          const empresaTransformada = await prepareEmpresaDesdeAFIP(r[0]);
          dispatch(empresaTraerAFIPSuccess(empresaTransformada));
          //console.log("respuesta servicio", r);
          const { empresa } = getState().empresas;
          dispatch(finishSpinner());
          return empresa;
        } else {
          console.log("respuesta error", response);
          throw new Error(response);
        }
      } else {
        dispatch(empresaTraerAFIPError(response.statusText));
        throw Error(response.statusText);
      }
   
    } catch (error) {
      console.log("error en afip ute", error);
      dispatch(empresaTraerAFIPError(error));
    }
  };
};
// export const validarEmpresa = (CUIT)=>{
//   return  (dispatch,getState) =>{

//     if (CUIT.length===11){
//        dispatch(fetchEmpresaXCUIT(CUIT));
//       const { empresa, cargada } = getState().empresas;
//       console.log('cargada',cargada,'empresa',empresa);
//       if (cargada && empresa){
//         dispatch(startAlerta(`Empresa Existente`,'info',empresa.denominacion));
//       }else{
//         console.log('fetch afip')
//         dispatch(fetchAFIP(CUIT));
//         console.log('cargadaafip',cargada,'empresaafip',empresa);
//         if (cargada && empresa?.EstadoAFIP!=='ACTIVO') {
//          console.log('habilita carga');

//         }else{

//           dispatch(startAlerta(`El CUIT ingresado no se encuentra de alta en AFIP`,'error','Verifique CUIT'));
//         }
//       }
//     }
//   }
// }

export const fetchEmpresaXCUIT = (CUIT) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(empresaTraerPorCUITStart());
    const response = await fetchConToken(`empresas/traerPorCUIT/${CUIT}`);
    if (!response.ok) {
      dispatch(empresaTraerPorCUITError());
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        dispatch(empresaTraerPorCUITSuccess(lista[0]));
        //return lista[0];
        const { empresa } = getState().empresas;
        dispatch(finishSpinner());
        return empresa;
        //console.log('empresa retorno',empresa);
      }
    }
    dispatch(finishSpinner());
  };
};


export const fetchAfiliadoXCUIL = (CUIL) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(empresaTraerPorCUITStart());
    const response = await fetchConToken(`empresas/traerPorCUIT/${CUIL}`);
    if (!response.ok) {
      dispatch(empresaTraerPorCUITError());
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        console.log("****;"+JSON.stringify(lista));
        dispatch(empresaTraerPorCUITSuccess(lista[0]));
        
        //return lista[0];
        const { empresa } = getState().empresas;
        return empresa;
        //console.log('empresa retorno',empresa);
      }
    }
    dispatch(finishSpinner());
  };
};